import React from "react";
import Icon from "components/AppIcon";

const QuestionOverviewPanel = ({ totalQuestions, answers, currentIndex, onNavigate }) => {
  return (
    <div
      className="rounded-xl p-4 md:p-5"
      style={{ backgroundColor: "var(--color-card)", border: "1px solid var(--color-border)" }}
    >
      <div className="flex items-center gap-2 mb-4">
        <Icon name="LayoutGrid" size={16} color="var(--color-primary)" strokeWidth={2} />
        <h3
          className="font-semibold text-sm md:text-base"
          style={{ color: "var(--color-text-primary)" }}
        >
          Aperçu des questions
        </h3>
      </div>
      <div className="grid grid-cols-5 gap-2">
        {Array.from({ length: totalQuestions }, (_, i) => {
          const isAnswered = answers?.[i] !== undefined && answers?.[i] !== null;
          const isCurrent = i === currentIndex;
          return (
            <button
              key={i}
              onClick={() => onNavigate(i)}
              className="w-full aspect-square rounded-lg flex items-center justify-center text-xs font-mono font-semibold transition-all duration-150 hover:scale-105"
              style={{
                backgroundColor: isCurrent
                  ? "var(--color-primary)"
                  : isAnswered
                  ? "var(--color-success)"
                  : "var(--color-muted)",
                color: isCurrent || isAnswered
                  ? "white" :"var(--color-muted-foreground)",
                border: isCurrent
                  ? "2px solid var(--color-primary)"
                  : isAnswered
                  ? "2px solid var(--color-success)"
                  : "2px solid var(--color-border)",
              }}
              aria-label={`Question ${i + 1}${isAnswered ? " (répondue)" : ""}${isCurrent ? " (actuelle)" : ""}`}
            >
              {i + 1}
            </button>
          );
        })}
      </div>
      <div className="mt-4 space-y-2">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: "var(--color-primary)" }} />
          <span className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>
            Question actuelle
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: "var(--color-success)" }} />
          <span className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>
            Répondue ({Object.keys(answers)?.length}/{totalQuestions})
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-sm flex-shrink-0"
            style={{ backgroundColor: "var(--color-muted)", border: "1px solid var(--color-border)" }}
          />
          <span className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>
            Non répondue
          </span>
        </div>
      </div>
    </div>
  );
};

export default QuestionOverviewPanel;